module.exports = __webpack_public_path__ + "c24af1a18a2ad22a0990b762449505c4.svg";